import { TODO } from '@b2b/types/core/utils';
import angular, { IScope } from 'angular';

export const TextareaFieldDirectiveModule = angular
  .module('acme.common.directive.textareaField', [])
  .directive('textareaField', [
    function TextareaFieldDirective() {
      return {
        restrict: 'A',
        replace: true,
        templateUrl: 'common/directives/textareaField/textareaField.tpl.html',
        scope: {
          type: '@',
          name: '@',
          label: '@',
          addon: '@',
          model: '=',
          hasAddon: '@hasaddon',
          hideLabel: '@hidelabel',
          validTest: '=validtest',
          errorMessage: '=errormessage',
          isPanelGroup: '@ispanelgroup',
          placeholderValue: '@placeholdervalue',
          customClass: '@customClass',
        },
        link: function ($scope, $element, $attrs) {
          // Modified after controller runs
        },

        controller: [
          '$scope',
          function TextareaField(
            $scope: IScope & {
              textareaField: TODO;
              placeholderValue: TODO;
              isPanelGroup: TODO;
              validTest: TODO;
            }
          ) {
            $scope.textareaField = {
              placeholder: $scope.placeholderValue || '',
              groupTypeClass: $scope.isPanelGroup ? 'panel-form-group' : 'form-group',
              checkValid: function () {
                return $scope.validTest !== undefined ? $scope.validTest : true;
              },
            };
          },
        ],
      };
    },
  ]).name;
